import { useQuery, useMutation } from "react-query";
import {
	getAllRestaurants_api,
	addRestaurant_api,
	updateRestaurant_api,
	deleteRestaurant_api,
	getRestaurantDetails_api,
	updateRestaurantContact_api,
	updateRestaurantSettings,
	downloadRestaurants_api,
	getOrderByRestaurant_api,
	reactivateRestaurant_api,
	deactivateRestaurant_api,
	getFranchiseStores_api,
	updateBusinessType_api,
	approveRestaurant_api,
	updateRestaurantGiftSettings,
	getRestaurantSettings,
	getRestaurantTaxInfo,
	getTaxMasterRestaurant,
	updateTaxMasterRestaurant,
	getAllPartners_api,
	addPartnership_api,
	getPartnerships_api,
} from "../services/restaurant";

export const useGetAllRestaurants = (params) =>
	useQuery(["getAllRestaurants", params], () => getAllRestaurants_api(params));

export const useGetRestaurantDetails = (params) =>
	useQuery(["getRestaurantDetails", params], () =>
		getRestaurantDetails_api(params)
	);

export const useAddRestaurant = () =>
	useMutation("addRestaurant", (body) => addRestaurant_api(body));

export const useUpdateRestaurant = () =>
	useMutation("updateRestaurant", (id) => updateRestaurant_api(id));

export const useDeleteRestaurant = () =>
	useMutation("deleteRestaurant", (id) => deleteRestaurant_api(id));

export const useUpdateRestaurantContact = () =>
	useMutation("updateRestaurantContact", (id) =>
		updateRestaurantContact_api(id)
	);

export const useUpdateRestaurantSettings = () =>
	useMutation("updateRestaurantSettings", (payload) =>
		updateRestaurantSettings(payload)
	);

export const useGetRestaurantSettings = (payload) =>
	useQuery(
		["getRestaurantSettings", payload],
		() => getRestaurantSettings(payload),
		{ enabled: !!payload }
	);

export const useDownloadRestaurants = () =>
	useMutation("downloadRestaurants", (payload) =>
		downloadRestaurants_api(payload)
	);

export const useGetOrderByRestaurant = (id) =>
	useQuery(["getOrderByRestaurant", id], () => getOrderByRestaurant_api(id));

export const useDeactivateRestaurant = () =>
	useMutation("deactivateRestaurant", (id) => deactivateRestaurant_api(id));

export const useReactivateRestaurant = () =>
	useMutation("reactivateRestaurant", (id) => reactivateRestaurant_api(id));

export const useGetFranchiseStores = (payload) =>
	useQuery(["getFranchiseStores", payload], () =>
		getFranchiseStores_api(payload)
	);

export const useUpdateBussinessType = () =>
	useMutation("updateRestaurantCommission", (payload) =>
		updateBusinessType_api(payload)
	);
export const useUpdatePartnershipType = () =>
	useMutation("updatePartnership", (payload) =>
		updateBusinessType_api(payload)
	);

export const useApproveRestaurant = () =>
	useMutation("approveRestaurant", (id) => approveRestaurant_api(id));

export const useUpdateRestaurantGiftSettings = () =>
	useMutation("updateRestaurantGiftSettings", (payload) =>
		updateRestaurantGiftSettings(payload)
	);

export const useGetRestaurantTaxInfo = (restaurantId) =>
	useQuery(["getRestaurantTaxInfo", restaurantId], () =>
		getRestaurantTaxInfo(restaurantId)
	);

export const useGetTaxMasterRestaurant = (restaurantId) =>
	useQuery(
		["taxMasterRestaurant", restaurantId],
		() => getTaxMasterRestaurant(restaurantId),
		{ enabled: !!restaurantId }
	);

export const useUpdateTaxMasterAddress = () =>
	useMutation("updateTaxMasterAddress", (payload) =>
		updateTaxMasterRestaurant(payload)
	);

export const useGetAllPartner = () =>
	useQuery(["getAllPartners"], () => getAllPartners_api());

export const useAddPartnership = () =>
	useMutation("addPartnership", (body) => addPartnership_api(body));

export const useGetPartnerships = (params) =>
	useQuery(["getPartnerships", params], () => getPartnerships_api(params));
